module.exports = __webpack_public_path__ + "static/media/camel_w_565.c8806059.jpg";